/** Backpack 取引所のアカウントカテゴリ識別子 */
export const backpackAccountCategory = 'backpack'

/**
 * Backpack の `DepositSource` / `Withdrawal.blockchain` 値から EVM チェーン ID への変換マップ。
 * 入金・出金履歴の `transactionHash` から EVM ソースを生成する際に利用する。
 */
export const networkEvmChainIds: Record<string, number | undefined> = {
  arbitrum: 42161,
  avalanche: 43114,
  base: 8453,
  berachain: 80094,
  bsc: 56,
  ethereum: 1,
  hyperEVM: 999,
  linea: 59144,
  monad: 143,
  optimism: 10,
  plasma: 9745,
  polygon: 137,
  sei: 1329,
  story: 1514,
}

/** Solana 系チェーン識別子の集合 (Backpack の `DepositSource` 値) */
export const solanaNetworks = new Set<string>(['solana', 'eclipse', 'fogo'])
